import { render, staticRenderFns } from "./VaccinationCertificateVerification.vue?vue&type=template&id=2efaaf9e&scoped=true"
import script from "./VaccinationCertificateVerification.vue?vue&type=script&lang=js"
export * from "./VaccinationCertificateVerification.vue?vue&type=script&lang=js"
import style0 from "./VaccinationCertificateVerification.vue?vue&type=style&index=0&id=2efaaf9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efaaf9e",
  null
  
)

export default component.exports